import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../components";
import Select from "react-select";
import { reqToGetAdminCourseList } from "../../store/slice/coursesSlice";
import { reqToMedRepRegistration } from "../../store/slice/userSlice";
import { registrationValidations } from "../../helpers/formValidation";
import { useForm } from "../../hooks/useForm";
import { notify } from "../../helpers/commonFunction";
import { Button, Form } from "react-bootstrap";

const Registration = () => {
  const dispatch = useDispatch();
  const { loader: userLoader } = useSelector((state) => state.userReducer);
  const { loader, courseList } = useSelector((state) => state.coursesReducer);

  const initialValues = {
    first_name: null,
    last_name: null,
    email: null,
    course: [],
  };
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    return registrationValidations(
      fieldValues,
      temp,
      values,
      setValues,
      setErrors
    );
  };
  const { errors, setErrors, values, setValues, handleInputChange } = useForm(
    initialValues,
    true,
    validate
  );

  useEffect(() => {
    handleGetInitialdata();
  }, []);

  const coursesOptions = useMemo(() => {
    const options =
      (Array.isArray(courseList) &&
        courseList.map((course) => ({
          ...course,
          label: course.name,
          value: course.id,
        }))) ||
      [];
    return options;
  }, [courseList]);

  const handleGetInitialdata = () => {
    dispatch(reqToGetAdminCourseList({ dispatch }));
  };

  const handleSubmitRegistration = (e) => {
    e.preventDefault();
    if (!validate()) return;
    const getCourse = values?.course.map((item) => item?.value);
    const reqObj = {
      ...values,
      course: getCourse,
    };
    dispatch(
      reqToMedRepRegistration({
        data: reqObj,
        onSuccess: () => {
          notify(
            `${values?.last_name} ${values?.first_name} successfully register!`,
            "success"
          );
          setValues(initialValues);
        },
        dispatch,
      })
    );
  };

  return (
    <>
      {(loader || userLoader) && <Loader />}
      <div className="lms-body">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="lms-profile-wrapper mb-0">
            <span className="lms-profile-name">REGISTRATION</span>
          </div>
          <div className="text-end fs-18">
            <p className="mb-0 fw-semibold">August 2025</p>
            <p className="mb-0">As of Tuesday, August 19</p>
          </div>
        </div>
        <div className="lms-content-wrapper lms-content-text d-flex flex-column align-items-center justify-content-center">
          <div className="login-container shadow border-3 py-4 px-4 rounded-3 lms-registration">
            <div className="login-header">
              <h1>Sign up with email</h1>
            </div>
            <div className="login-body mt-5 px-5">
              <Form className="d-flex flex-column justify-content-center input-group">
                <Form.Group
                  className="mb-4 d-flex align-items-center gap-3"
                  controlId="first_name"
                >
                  <Form.Label className="mb-0">
                    First Name <span>:</span>
                  </Form.Label>
                  <div>
                    <Form.Control
                      type="text"
                      name="first_name"
                      placeholder="Enter firstname"
                      value={values?.first_name}
                      onChange={handleInputChange}
                    />
                    <span className="lms_error_text">
                      {errors && errors.first_name}
                    </span>
                  </div>
                </Form.Group>
                <Form.Group
                  className="mb-4 d-flex align-items-center gap-3"
                  controlId="last_name"
                >
                  <Form.Label className="mb-0">
                    Last Name <span>:</span>
                  </Form.Label>
                  <div>
                    <Form.Control
                      type="text"
                      name="last_name"
                      placeholder="Enter lastname"
                      value={values?.last_name}
                      onChange={handleInputChange}
                    />
                    <span className="lms_error_text">
                      {errors && errors.last_name}
                    </span>
                  </div>
                </Form.Group>
                <Form.Group
                  className="mb-4 d-flex align-items-center gap-3"
                  controlId="email"
                >
                  <Form.Label className="mb-0">
                    Email <span>:</span>
                  </Form.Label>
                  <div>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter email"
                      value={values?.email}
                      onChange={handleInputChange}
                    />
                    <span className="lms_error_text">
                      {errors && errors.email}
                    </span>
                  </div>
                </Form.Group>
                <Form.Group
                  className="mb-4 d-flex align-items-center gap-3"
                  controlId="course"
                >
                  <Form.Label className="mb-0">
                    Course <span>:</span>
                  </Form.Label>
                  <div className="flex-grow-1">
                    <Select
                      isMulti
                      id="course"
                      name="course"
                      options={coursesOptions}
                      className="lms-custom-select"
                      placeholder="Select course..."
                      value={values?.course}
                      onChange={(e) => handleInputChange(e, "course")}
                      isClearable={false}
                    />
                    <span className="lms_error_text">
                      {errors && errors.course}
                    </span>
                  </div>
                </Form.Group>
                <Button
                  type="submit"
                  variant="primary"
                  className="mx-auto"
                  onClick={handleSubmitRegistration}
                >
                  SUBMIT
                </Button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Registration;
